$(document).ready(function(){

// ---------------------------------------------------------------------------
// Scope helpers.
// The Personalize panel markup is rendered once per product section. On a PDP
// there is exactly one section, but on pages that preload quick-view modals
// (e.g. the Travel Stories hot spots) there can be many on the same page. Every
// lookup below runs inside the section that owns the active panel so the right
// product's variant data, inputs and buttons are read.
// ---------------------------------------------------------------------------
var monogramActiveScope = null;

function monogramScopeFrom(el) {
  var section = el ? $(el).closest('.product-section') : $();
  return section.length ? section[0] : null;
}

function monogramScope() {
  if (monogramActiveScope && document.contains(monogramActiveScope)) {
    return monogramActiveScope;
  }
  var openWrapper = document.querySelector('.monogram-outer-wrapper.is-open');
  if (openWrapper) {
    return monogramScopeFrom(openWrapper) || document;
  }
  var sections = document.querySelectorAll('.product-section');
  return sections.length === 1 ? sections[0] : document;
}

// True when lookups would run page-wide because no single product section can
// be resolved (several sections on the page and no active panel). Callers that
// rewrite panel markup must not run in that state.
function monogramScopeUnresolved() {
  return monogramScope() === document && document.querySelectorAll('.product-section').length > 1;
}

// Focus management for the panel (it is a dialog layered over the product
// form or the quick-view modal).
function monogramFocusPanel(outerWrapper) {
  var closeBtn = outerWrapper.find('.monogram-modal-container button.modal-close-btn')[0];
  if (closeBtn) closeBtn.focus();
}
function monogramRestoreFocus(outerWrapper) {
  var opener = outerWrapper.find('.monogram-modal-open')[0];
  if (opener && opener.offsetParent !== null) opener.focus();
}

// Keep keyboard focus inside the open panel (it is announced as a modal
// dialog). Tab from the last control wraps to the first and Shift+Tab from the
// first wraps to the last; focus that lands outside the panel is pulled back
// to its close button. Independent of the theme's own modal focus trap so the
// quick view's trap is left untouched.
function monogramPanelFocusables(container) {
  return [].slice.call(container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'))
    .filter(function(el) { return el.offsetParent !== null && !el.disabled; });
}
document.addEventListener('keydown', function(e) {
  if (e.key !== 'Tab') return;
  var container = document.querySelector('.monogram-outer-wrapper.is-open .monogram-modal-container');
  if (!container) return;
  var focusables = monogramPanelFocusables(container);
  if (!focusables.length) return;
  var first = focusables[0], last = focusables[focusables.length - 1];
  if (!container.contains(document.activeElement)) {
    e.preventDefault(); first.focus(); return;
  }
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
});
document.addEventListener('focusin', function(e) {
  var container = document.querySelector('.monogram-outer-wrapper.is-open .monogram-modal-container');
  if (!container || container.contains(e.target)) return;
  var closeBtn = container.querySelector('button.modal-close-btn');
  if (closeBtn) closeBtn.focus();
});

// jQuery lookup restricted to the active product section
function $m(selector) {
  return $(monogramScope()).find(selector);
}

// Quick-view modals suffix every id in the lazily loaded product form with
// "-modal" (theme.js openModalProduct), so both ids are accepted.
function monogramVariantDataScript() {
  var scope = monogramScope();
  var scoped = scope.querySelector ? scope.querySelector('#variant-monogram-data, #variant-monogram-data-modal') : null;
  return scoped || document.querySelector('#variant-monogram-data');
}

// Suffix that keeps generated input ids unique per panel: the section's product
// id, plus "-modal" when the section lives in a quick-view modal (a PDP can show
// its own product again in a recommendation quick view).
function monogramIdSuffix() {
  var scope = monogramScope();
  if (!scope || !scope.getAttribute) return '';
  var suffix = '-' + (scope.getAttribute('data-product-id') || '');
  if (scope.closest('.modal--quick-shop')) suffix += '-modal';
  return suffix;
}

// True when the active panel lives inside a quick-view modal. The quick-view
// modal owns the page scroll lock in that case, so the panel must not toggle it.
function monogramInQuickView() {
  var scope = monogramScope();
  return !!(scope && scope.closest && scope.closest('.modal--quick-shop'));
}

// Function to prevent body scrolling
function preventBodyScroll() {
  if (monogramInQuickView()) return;
  document.body.classList.add('modal-open');
}

// Function to enable body scrolling
function enableBodyScroll() {
  if (monogramInQuickView()) return;
  document.body.classList.remove('modal-open');
}

// Delegated so the button also works inside quick-view modals, whose markup is
// injected after page load.
$(document).on('click', '.monogram-modal-open', function(){ 
  monogramActiveScope = monogramScopeFrom(this);

  // get closest 'monogram-outer-wrapper' then find the child .monogram-modal-container and add class 'is-open'
  const outerWrapper = $(this).closest('.monogram-outer-wrapper');
  outerWrapper.addClass('is-open');
  // Always open at the top, even if the panel was scrolled before it was closed
  outerWrapper.find('.monogram-modal-content, .monogram-wrap').scrollTop(0);
  monogramFocusPanel(outerWrapper);
  
  // Prevent body scrolling when modal opens
  preventBodyScroll();
  
  // Hide modal initially to prevent visual jumping during reset
  $m('.monogram-modal-container').css('opacity', '0');
  
 
  // Initialize color swatches when modal opens
  setTimeout(function() {
    // Clear all existing selections first to ensure clean state
    $m('.monogram-swatch-wrapper').removeClass('is-selected');
    $m('input[name^="monogram-style"], input[name^="monogram-color"]').prop('checked', false);
    
    // Clear hidden property inputs to remove any previous values
    $m('[id^="monogram-style-property"]').val('');
    $m('[id^="monogram-color-property"]').val('');
    
    // Clear title attributes and text content on monogram text overlays
    $m('.monogram-text-overlay').attr('title', '').text('');
    
    // Clear any existing font size styles to prevent conflicts
    $m('.monogram-text-overlay').css('font-size', '');
    
    // Clear monogram input field
    $m('.monogram__input-field').val('');
    
    const firstStyleInput = $m('input[name^="monogram-style"]').first();
    if (firstStyleInput.length) {
      const firstStyle = firstStyleInput.val();
      const colorSwatches = $m('.color-swatch-wrapper');
      
      // Hide all color swatches first
      colorSwatches.hide();
      
      // Select the first style option and add is-selected class
      firstStyleInput.prop('checked', true);
      firstStyleInput.closest('.monogram-swatch-wrapper').addClass('is-selected');
      
      // Only show color swatches if the first style is 'Color'
      if (firstStyle.includes('Color')) {
        // Show the color options section
        $m('.monogram-color-options').show();
        
        // Show all color swatches when the first style includes "Color"
        colorSwatches.each(function() {
          $(this).show();
        });
        
        // Select the first visible color option and add is-selected class
        const firstVisibleColorInput = $m('.color-swatch-wrapper:visible input[name^="monogram-color"]').first();
        if (firstVisibleColorInput.length) {
          firstVisibleColorInput.prop('checked', true);
          firstVisibleColorInput.closest('.color-swatch-wrapper').addClass('is-selected');
        }
      } else {
        // Hide the entire color options section for Embossed style
        $m('.monogram-color-options').hide();
      }
      
      // Update displays and properties AFTER setting selections
      updateColorNameDisplay();
      updateMonogramProperties();
      updatePriceVisibility();
      
      // Initially disable the ADD TO CART button
      $m('.monogram-modal-atc-btn').prop('disabled', true).addClass('btn--disabled');
      
      // Update text overlay color based on the selected style
      if (firstStyle === 'Embossed') {
        syncEmbossedColorWithMainVariant();
        // Also update text overlay to use embossed color
        updateMonogramTextOverlayToEmbossedColor();
      } else {
        // Update monogram text overlay color for other styles
        updateMonogramTextOverlayColor();
      }
      
      // Fade in the modal after all resets are complete
      $m('.monogram-modal-container').css('opacity', '1');
    } else {
      // If no style inputs exist, still fade in the modal
      $m('.monogram-modal-container').css('opacity', '1');
    }
  }, 100); // Small delay to ensure modal is fully rendered
  
  // Safety timeout - ensure modal is never permanently invisible
  setTimeout(function() {
    $m('.monogram-modal-container').css('opacity', '1');
  }, 500); // 500ms backup timeout
});

// Close modal when close button is clicked
$(document).on('click', '.modal-close-btn', function(){
  monogramActiveScope = monogramScopeFrom(this);
  const outerWrapper = $(this).closest('.monogram-outer-wrapper');
  outerWrapper.removeClass('is-open');
  monogramRestoreFocus(outerWrapper);
  
  // Enable body scrolling when modal closes
  enableBodyScroll();
});

// Close modal when clicking outside the modal content
$(document).on('click', '.monogram-modal-container', function(e){
  // Check if the click was directly on the modal container (overlay) and not on its children
  if (e.target === this) {
    monogramActiveScope = monogramScopeFrom(this);
    const outerWrapper = $(this).closest('.monogram-outer-wrapper');
    outerWrapper.removeClass('is-open');
    monogramRestoreFocus(outerWrapper);
    
    // Enable body scrolling when modal closes
    enableBodyScroll();
  }
});

// Close modal with Escape key. Listens on keyup (the same event the theme's
// modals and drawers use, bound on window) and stops the event here on document,
// so an Escape that closes the Personalize panel does not also close a
// quick-view modal or drawer underneath it.
$(document).on('keyup', function(e){
  if (e.key === 'Escape' && $('.monogram-outer-wrapper.is-open').length > 0) {
    e.stopPropagation();
    const openWrapper = $('.monogram-outer-wrapper.is-open');
    monogramActiveScope = monogramScopeFrom(openWrapper[0]);
    $('.monogram-outer-wrapper.is-open').removeClass('is-open');
    monogramRestoreFocus(openWrapper);
    
    // Enable body scrolling when modal closes
    enableBodyScroll();
  }
});

// Monogram swatch selection handling
$(document).on('change', '.monogram-swatch-input', function(){
  monogramActiveScope = monogramScopeFrom(this);
  const wrapper = $(this).closest('.monogram-swatch-wrapper');
  const name = $(this).attr('name');
  
  // Remove is-selected class from all siblings with the same name
  wrapper.siblings().find(`input[name="${name}"]`).closest('.monogram-swatch-wrapper').removeClass('is-selected');
  
  // Add is-selected class to current wrapper
  wrapper.addClass('is-selected');
  
  // If this is a style swatch, show/hide relevant color swatches
  // Radio names carry the product id (monogram-style-<id>[-modal]); match by prefix
  if (name.indexOf('monogram-style') === 0) {
    const selectedStyle = $(this).val();
    const colorSwatches = $m('.color-swatch-wrapper');
    
    // Hide all color swatches first
    colorSwatches.hide();
    
    // Clear any selected color when style changes
    $m('input[name^="monogram-color"]').prop('checked', false);
    $m('.color-swatch-wrapper').removeClass('is-selected');
    
    // Only show color swatches if the selected style is 'Color'
    if (selectedStyle.includes('Color')) {
      // Show the color options section
      $m('.monogram-color-options').show();
      
      // Show all color swatches when the style includes "Color"
      colorSwatches.each(function() {
        $(this).show();
      });
      
      // Auto-select the first visible color swatch
      const firstVisibleColorInput = $m('.color-swatch-wrapper:visible input[name^="monogram-color"]').first();
      if (firstVisibleColorInput.length) {
        firstVisibleColorInput.prop('checked', true);
        firstVisibleColorInput.closest('.color-swatch-wrapper').addClass('is-selected');
      }
    } else {
      // Hide the entire color options section for Embossed style
      $m('.monogram-color-options').hide();
    }
    
    // Update color name display
    updateColorNameDisplay();
    
    // Update monogram properties
    updateMonogramProperties();
    
    // Show/hide price based on selected style
    updatePriceVisibility();
    
    // Sync embossed color swatch if Embossed style is selected
    if (selectedStyle === 'Embossed') {
       syncEmbossedColorWithMainVariant();
      // Also update text overlay to use embossed color
      updateMonogramTextOverlayToEmbossedColor();
    } else {
       // Update monogram text overlay color for other styles
      updateMonogramTextOverlayColor();
    }
  }
  
  // If this is a color swatch, update the color name display and text overlay color
   if (name.indexOf('monogram-color') === 0) {
    updateColorNameDisplay();
    updateMonogramTextOverlayColor();
  }
  
  // Update hidden property inputs when selections change
  updateMonogramProperties();
});

// Function to sync embossed color with main product variant
// This function updates the embossed color data attribute when variant changes
function syncEmbossedColorWithMainVariant() { 
  
  // Find the Embossed style swatch label
  const embossedStyleLabel = $m('.monogram-swatch-wrapper input[value="Embossed"]').next('label');
  if (!embossedStyleLabel.length) {
    return;
  }
   
  // Find the currently selected main product variant
  const selectedVariantInput = $m('input[data-variant-input]:checked');
  if (!selectedVariantInput.length) { 
    return;
  }
   
  // Get the variant data from the JSON
  const colorOptionsScript = monogramVariantDataScript();
  if (!colorOptionsScript) {
    return;
  }
  
  try {
    const variantData = JSON.parse(colorOptionsScript.textContent);
    const selectedVariantId = selectedVariantInput.data('variant-id');
    
    if (selectedVariantId && variantData[selectedVariantId]) {
      // If the variant has embossed_text_color, use that
      if (variantData[selectedVariantId].embossed_text_color) {
        embossedStyleLabel.data('embossed-color', variantData[selectedVariantId].embossed_text_color);
      }
    }
  } catch (error) {
    console.log('Error parsing variant data:', error);
  }
  
  // Update monogram text overlay color if Embossed style is selected
  if ($m('input[name^="monogram-style"]:checked').val() === 'Embossed') {
    updateMonogramTextOverlayToEmbossedColor();
  }
}

// Function to update monogram text overlay to embossed color from style swatch data attribute
function updateMonogramTextOverlayToEmbossedColor() {
   
  // Get embossed color from style swatch data attribute
  const embossedStyleLabel = $m('.monogram-swatch-wrapper input[value="Embossed"]').next('label');
   
  let embossedColor = null;
  
  if (embossedStyleLabel.length) {
    embossedColor = embossedStyleLabel.data('embossed-color');
  }
    
  if (embossedColor) {
    // Find all monogram text overlays and update their color
    const textOverlays = $m('.monogram-text-overlay'); 
    
    // Clear any gradient styles for embossed (gradients don't apply to embossed)
    textOverlays.css({
      'background': '',
      'background-clip': '',
      '-webkit-background-clip': '',
      '-webkit-text-fill-color': '',
      'color': embossedColor // Set the solid color after clearing gradient properties
    });
  }  
}

// Function to update monogram text overlay color based on selected color swatch
function updateMonogramTextOverlayColor() {
 
  
  const selectedColorInput = $m('input[name^="monogram-color"]:checked');
  if (!selectedColorInput.length) { 
    return;
  }
   
  const selectedColorSwatch = selectedColorInput.next('label.color-swatch');
  if (!selectedColorSwatch.length) { 
    return;
  }
   
  // Check if embossed style is selected - gradients don't apply to embossed
  const selectedStyle = $m('input[name^="monogram-style"]:checked').val();
  if (selectedStyle === 'Embossed') {
    return; // Don't apply gradients to embossed style
  }
   
  // Get the selected color name to match with gradient data
  const selectedColorName = selectedColorInput.val();
  
  // Get variant data to check for gradient colors
  const selectedVariantInput = $m('input[data-variant-input]:checked');
  if (!selectedVariantInput.length) {
    return;
  }
  
  const selectedVariantId = selectedVariantInput.data('variant-id');
  const variantDataScript = monogramVariantDataScript();
  
  if (variantDataScript) {
    try {
      const variantData = JSON.parse(variantDataScript.textContent);
      const currentVariantData = variantData[selectedVariantId];
      
      if (currentVariantData) {
        // Check if gradient colors are available for the selected color
        const gradientColors = getGradientColorsForColor(currentVariantData, selectedColorName);
        
        if (gradientColors) {
          // Apply gradient effect
          applyGradientToTextOverlay(gradientColors);
          return;
        }
      }
    } catch (error) {
      console.log('Error parsing variant data for gradient:', error);
    }
  }
  
  // Fallback to solid color if no gradient is available
  const swatchBgColor = selectedColorSwatch.css('background-color'); 
  
  // Find all monogram text overlays and update their color
  const textOverlays = $m('.monogram-text-overlay');
  
  // Remove any existing gradient styles and set solid color
  textOverlays.css({
    'background': '',
    'background-clip': '',
    '-webkit-background-clip': '',
    '-webkit-text-fill-color': '',
    'color': swatchBgColor
  });
}

// Function to get gradient colors for a specific color name
function getGradientColorsForColor(variantData, colorName) {
  // Get color options to determine which color index this is
  const colorOptions = variantData.color_options;
  if (!colorOptions || !Array.isArray(colorOptions)) {
    return null;
  }
  
  // Find the index of the selected color
  let colorIndex = -1;
  for (let i = 0; i < colorOptions.length; i++) {
    const colorOption = colorOptions[i];
    const colorParts = colorOption.split('[');
    const optionColorName = colorParts[0].trim();
    
    if (optionColorName === colorName) {
      colorIndex = i;
      break;
    }
  }
  
  if (colorIndex === -1) {
    return null;
  }
  
  // Determine which gradient set to use (color_1 or color_2)
  let gradientTopColor, gradientBottomColor;
  
  if (colorIndex === 0) {
    // First color - use color_1 gradient
    gradientTopColor = variantData.color_1_gradient_top_color;
    gradientBottomColor = variantData.color_1_gradient_bottom_color;
  } else if (colorIndex === 1) {
    // Second color - use color_2 gradient
    gradientTopColor = variantData.color_2_gradient_top_color;
    gradientBottomColor = variantData.color_2_gradient_bottom_color;
  } else {
    return null; // Only support first two colors for gradients
  }
  
  // Check if both gradient colors are available
  if (gradientTopColor && gradientBottomColor && 
      gradientTopColor !== 'null' && gradientBottomColor !== 'null') {
    return {
      top: gradientTopColor,
      bottom: gradientBottomColor
    };
  }
  
  return null;
}

// Function to apply gradient effect to text overlay
function applyGradientToTextOverlay(gradientColors) {
  const textOverlays = $m('.monogram-text-overlay');
  
  // Create gradient CSS
  const gradientCSS = `linear-gradient(to bottom, ${gradientColors.top}, ${gradientColors.bottom})`;
  
  // Apply gradient styles
  textOverlays.css({
    'background': gradientCSS,
    'background-clip': 'text',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
    'color': gradientColors.top // Fallback color for browsers that don't support background-clip: text
  });
}

// Function to update hidden monogram property inputs
function updateMonogramProperties() {
  const selectedStyle = $m('input[name^="monogram-style"]:checked').val();
  const selectedColor = $m('input[name^="monogram-color"]:checked').val();
  const monogramText = $m('.monogram__input-field').val();
  
  // Set style property
  $m('[id^="monogram-style-property"]').val(selectedStyle || '');
  
  // Only set color property if a color is actually selected
  // For styles like Embossed that don't require color, clear the color property
  if (selectedColor) {
    $m('[id^="monogram-color-property"]').val(selectedColor);
  } else {
    $m('[id^="monogram-color-property"]').val('');
  }
  
  // Update ADD TO CART button state
  updateAddToCartButtonState();
}

// Function to update ADD TO CART button state
function updateAddToCartButtonState() {
  const selectedStyle = $m('input[name^="monogram-style"]:checked').val();
  const selectedColor = $m('input[name^="monogram-color"]:checked').val();
  const monogramText = $m('.monogram__input-field').val();
  const atcButton = $m('.monogram-modal-atc-btn');
  
  // For Embossed style, color selection is not required
  const colorRequired = selectedStyle !== 'Embossed';
  
  // Enable button if style is selected, text is valid, and color is selected (if required)
  if (selectedStyle && monogramText && monogramText.trim() !== '' && isValid(monogramText) && monogramText.length <= 3) {
    if (!colorRequired || selectedColor) {
      atcButton.prop('disabled', false);
      atcButton.removeClass('btn--disabled');
    } else {
      atcButton.prop('disabled', true);
      atcButton.addClass('btn--disabled');
    }
  } else {
    atcButton.prop('disabled', true);
    atcButton.addClass('btn--disabled');
  }
}

// Function to update the color name display
function updateColorNameDisplay() {
  const selectedColorInput = $m('input[name^="monogram-color"]:checked');
  const colorNameSpan = $m('.monogram-color-name');
  
  if (selectedColorInput.length) {
    const selectedColorName = selectedColorInput.val();
    colorNameSpan.text(' - ' + selectedColorName);
  } else {
    // If no color is selected, show the first visible color name
    const firstVisibleColorInput = $m('.color-swatch-wrapper:visible input[name^="monogram-color"]').first();
    if (firstVisibleColorInput.length) {
      colorNameSpan.text(' - ' + firstVisibleColorInput.val());
    } else {
      colorNameSpan.text(''); // Clear if no colors are visible
    }
  }
}

// Function to show/hide price based on selected style
function updatePriceVisibility() {
  const selectedStyle = $m('input[name^="monogram-style"]:checked').val(); 
  
  // Get the fee from the currently selected variant data
  let priceForColor = ''; // No default fee
  const selectedVariantInput = $m('input[data-variant-input]:checked');
  if (selectedVariantInput.length) {
    const selectedVariantId = selectedVariantInput.data('variant-id');
    const variantDataScript = monogramVariantDataScript();
    if (variantDataScript) {
      try {
        const variantData = JSON.parse(variantDataScript.textContent);
        const currentVariantData = variantData[selectedVariantId];
        if (currentVariantData && currentVariantData.color_foil_fee !== null && currentVariantData.color_foil_fee !== undefined && currentVariantData.color_foil_fee > 0) {
          priceForColor = '$' + currentVariantData.color_foil_fee;
        }
      } catch (error) {
        console.log('Error parsing variant data for fee:', error);
      }
    }
  }
  
  // const freeOption = 'Complimentary';
  
  // Update ADD TO CART button text
  let atcButton = $m('.monogram-modal-atc-btn span[data-add-to-cart-text]');
  if (atcButton.length === 0) {
    // Fallback to the button itself if span not found
    atcButton = $m('.monogram-modal-atc-btn');
  }
  const defaultAtcText = 'Add to Cart'; 
  
  // Update STYLE label text - find any element containing "STYLE" text
  // const styleLabels = $m('.monogram-modal-container *').filter(function() {
  //   const text = $(this).text().trim().toUpperCase();
  //   return (text === 'STYLE' || text.includes('STYLE (') || text.includes('STYLE<SPAN')) && 
  //          $(this).prop('tagName') === 'H4'; // Target H4 elements specifically
  // }); 
  
  if (selectedStyle && selectedStyle.toLowerCase().includes('color')) {
    // Show price for Color style only if fee is set
    if (priceForColor) {
      atcButton.text(defaultAtcText + ' (' + priceForColor + ')');
    } else {
      atcButton.text(defaultAtcText);
    }
    
    // Update STYLE label to include price
    // styleLabels.each(function() {
    //   const $this = $(this);
    //   // Remove any existing price spans
    //   $this.find('span.price').remove();
    //   // Set base text and add price span
    //   $this.html('STYLE <span class="price">(' + priceForColor + ')</span>');
    // });
     
  } else if (selectedStyle && selectedStyle === 'Embossed') {
    // Embossed style is free
    atcButton.text(defaultAtcText);
    
    // Update STYLE label to include complimentary
    // styleLabels.each(function() {
    //   const $this = $(this);
    //   // Remove any existing price spans
    //   $this.find('span.price').remove();
    //   // Set base text and add complimentary span
    //   $this.html('STYLE <span class="price">(' + freeOption + ')</span>');
    // });
    
  } else {
    // No selection or other style
    atcButton.text(defaultAtcText);
    
    // Remove price spans from STYLE label
    // styleLabels.each(function() {
    //   const $this = $(this);
    //   $this.find('span.price').remove();
    //   $this.text('STYLE');
    // });
  }

  // Update per-swatch notes under each style
  $m('.monogram-style-note').each(function() {
    const style = $(this).data('style');
    if (style === 'Embossed') {
      $(this).text('Complimentary');
    } else {
      if (priceForColor) {
        $(this).text('+' + priceForColor);
      } else {
        $(this).text('');
      }
    }
  });
}

// Initialize selected states for one product section (the page's on load, and
// each quick-view modal's product section when its markup is injected).
function monogramInitScope(section){
  monogramActiveScope = section || null;
  // Never write panel state page-wide; see monogramScopeUnresolved()
  if (monogramScopeUnresolved()) return;
  $m('.monogram-swatch-input:checked').each(function(){
    $(this).closest('.monogram-swatch-wrapper').addClass('is-selected');
  });
  
  // Update color name display on page load
  updateColorNameDisplay();
  
  // Update monogram properties on page load
  updateMonogramProperties();
  
  // Show/hide price based on initial style selection
  updatePriceVisibility();
  
  // Initially disable ADD TO CART buttons
  $m('.monogram-modal-atc-btn').prop('disabled', true).addClass('btn--disabled');
  
  // Initialize modal content for currently selected variant
  const initialVariantInput = $m('input[data-variant-input]:checked');
  if (initialVariantInput.length) {
    const initialVariantId = initialVariantInput.data('variant-id');
     
    
    if (!initialVariantId) { 
      return;
    }
    
    const variantDataScript = monogramVariantDataScript();
    if (variantDataScript) {
      try {
        const variantData = JSON.parse(variantDataScript.textContent);
        const currentVariantData = variantData[initialVariantId];
        if (currentVariantData) {
          updateModalForVariant(currentVariantData, initialVariantId);
        }
      } catch (error) { 
      }
    }
  }
}

$(document).ready(function(){
  monogramInitScope(null);
});

// Quick-view modals lazy-load their product form (and with it the Personalize
// panel markup) when first opened; theme.js announces that with
// 'quickview:loaded'. Initialize the panel for that modal's product section,
// then hand the scope back so page-load behaviour is unchanged.
// If a quick-view modal is dismissed while its Personalize panel is open (the
// page overlay outside the modal is still clickable), reset the panel so the
// modal reopens on the product view and no stale open panel is left behind.
document.addEventListener('modal:closed', function(e){
  var modal = e.detail && e.detail.modal;
  if (!modal || !modal.classList.contains('modal--quick-shop')) return;
  var openWrapper = modal.querySelector('.monogram-outer-wrapper.is-open');
  if (openWrapper) openWrapper.classList.remove('is-open');
  if (monogramActiveScope && modal.contains(monogramActiveScope)) monogramActiveScope = null;
});

document.addEventListener('quickview:loaded', function(e){
  var productId = e.detail && e.detail.productId;
  var modal = productId ? document.getElementById('QuickShopModal-' + productId) : null;
  var section = modal ? modal.querySelector('.product-section') : null;
  if (!section || !section.querySelector('.monogram-outer-wrapper')) return;
  monogramInitScope(section);
  toggleMonogramButton();
  monogramActiveScope = null;
});

// Listen for main product variant changes to update modal content
$(document).on('change', 'input[data-variant-input]', function() {
  monogramActiveScope = monogramScopeFrom(this);
  const selectedVariantInput = $(this);
  
  // Get the variant ID directly from the data attribute
  const selectedVariantId = selectedVariantInput.data('variant-id');
  
 
  
  if (!selectedVariantId) { 
    return;
  }
  
  // Get the variant monogram data from the JSON
  const variantDataScript = monogramVariantDataScript();
  if (!variantDataScript) { 
    return;
  }
  
  let variantData;
  try {
    variantData = JSON.parse(variantDataScript.textContent); 
  } catch (error) { 
    return;
  }
  
  const currentVariantData = variantData[selectedVariantId];
  if (!currentVariantData) { 
    return;
  }
   
  
  // Update modal content based on variant data
  updateModalForVariant(currentVariantData, selectedVariantId);
});

// Function to update modal content for selected variant
function updateModalForVariant(variantData, variantId) { 
  // Never rewrite panel markup page-wide; see monogramScopeUnresolved()
  if (monogramScopeUnresolved()) return;
  
  // Update ATC button variant ID
  const atcButton = $m('.monogram-modal-atc-btn');
 
  
  if (atcButton.length) {
    atcButton.attr('data-variant-id', variantId);
 
  } 
  
  // Show/hide monogram button based on has_monogram
  const monogramWrapper = $m('.monogram-outer-wrapper');
  if (variantData.has_monogram) {
    monogramWrapper.removeClass('monogram-hidden'); 
  } else {
    monogramWrapper.addClass('monogram-hidden'); 
    return; // No need to update other content if variant doesn't support monogramming
  }
  
  // Update modal image if available
  if (variantData.image_desktop) {
    const modalImage = $m('.monogram-modal-content-inner-left img, .monogram-modal-content-inner-left .monogram-custom-image');
    if (modalImage.length) {
      modalImage.attr('src', variantData.image_desktop); 
    }
  }
  
  // Update style options with variant data
  updateStyleOptionsForVariant(variantData);
  
  // Update Classic swatch with embossed_text_color or variant fallback
  updateClassicSwatchForVariant(variantData, variantId);
  
  // Update Color style swatches with color_options
  updateColorSwatchesForVariant(variantData);
  
  // Update text overlay positioning and rotation
  updateTextOverlayForVariant(variantData);
  
  // Update price visibility with new variant fee
  updatePriceVisibility();
  
  // Reset and initialize selections with the new variant data
  resetAndInitializeSelections();
  
  // Update font size AFTER content is recreated
  updateMonogramFontSize(variantData);
   
}

// Function to update Embossed style swatch with variant-specific data
function updateClassicSwatchForVariant(variantData, variantId) { 
  
  const embossedStyleLabel = $m('.monogram-swatch-wrapper input[value="Embossed"]').next('label');
  if (!embossedStyleLabel.length) { 
    return;
  }
  
  // If variant has embossed_text_color, use that color
  if (variantData.embossed_text_color && variantData.embossed_text_color !== null && variantData.embossed_text_color !== '') {
    embossedStyleLabel.data('embossed-color', variantData.embossed_text_color);
  }
  // Note: We don't fall back to variant swatch appearance here because the Liquid template
  // already handles the fallback logic and sets the correct color in the data attribute
}

  // Function to update Color style swatches with variant color options
  function updateColorSwatchesForVariant(variantData) { 
    const idSuffix = monogramIdSuffix();
    // Remove existing Color style swatches
    $m('.color-swatch-wrapper[data-style-option="Color"]').remove();
     if (variantData.color_options && variantData.color_options.length > 0) {
      let colorSwatchesHTML = '';
      
      variantData.color_options.forEach((colorOption, index) => { 
        
        // Parse color string like "Silver[#DFDFDF]"
        const colorParts = colorOption.split('[');
        const colorName = colorParts[0].trim();
        let colorHex = '';
        
        if (colorParts.length >= 2) {
          const colorHexPart = colorParts[1];
          if (colorHexPart.includes(']')) {
            colorHex = colorHexPart.split(']')[0].trim();
          }
        }
        
        const finalColor = colorHex || colorName;
        
        colorSwatchesHTML += `
          <div class="monogram-swatch-wrapper color-swatch-wrapper" data-style-option="Color" data-color-source="color_options">
            <input type="radio" name="monogram-color${idSuffix}" id="color-variant-${index + 1}${idSuffix}" value="${colorName}" class="monogram-swatch-input">
            <label for="color-variant-${index + 1}${idSuffix}" class="monogram-swatch color-swatch color-swatch--${colorName.toLowerCase().replace(/\s+/g, '-')}" style="background-color: ${finalColor};" title="${colorName}"></label>
          </div>
        `;
      });
      
      // Append new color swatches to the color options container
      $m('.monogram-color-options .monogram-swatch-group').append(colorSwatchesHTML);
    }
  }

  // Function to update style options for the variant
  function updateStyleOptionsForVariant(variantData) {
    // Only update if variant has different style options than currently shown
    if (variantData.style_options && variantData.style_options.length > 0) {
      // Remove existing style options
      $m('.monogram-style-options').remove();
      const idSuffix = monogramIdSuffix();
      
      const styleOptionsHTML = `
        <div class="monogram-style-options">
          <h4>Select A Style</h4>
          <div class="monogram-swatch-group">
            ${variantData.style_options.map((styleOption, index) => {
              // Add embossed color data attribute for Embossed style
              const embossedColorAttr = styleOption === 'Embossed' && variantData.embossed_text_color 
                ? `data-embossed-color="${variantData.embossed_text_color}"` 
                : '';
              
              return `
                <div class="monogram-swatch-wrapper">
                  <input type="radio" name="monogram-style${idSuffix}" id="style-${index + 1}${idSuffix}" value="${styleOption}" class="monogram-swatch-input">
                  <label for="style-${index + 1}${idSuffix}" class="monogram-swatch style-swatch style-swatch--${styleOption.toLowerCase().replace(/\s+/g, '-')}" title="${styleOption}" option-key="${styleOption}" ${embossedColorAttr}>
                    ${styleOption}
                  </label>
                  <div class="monogram-style-note" data-style="${styleOption}"></div>
                </div>
              `;
            }).join('')}
          </div>
        </div>
      `;
      
      // Insert after this panel's heading wrapper only
      $m('.custom-monogram-heading-wrapper').first().after(styleOptionsHTML);
    }
  }
  
  // Function to update text overlay positioning and rotation for variant
  function updateTextOverlayForVariant(variantData) {
    const textOverlay = $m('.monogram-text-overlay');
    const textBoundingBox = $m('.monogram-text-bounding-box');
    
    if (textOverlay.length && textBoundingBox.length) {
      // Update positioning if coordinates are provided
      if (variantData.x_coordinate !== undefined && variantData.y_coordinate !== undefined) {
        textBoundingBox.css({
          'top': variantData.y_coordinate + '%',
          'left': variantData.x_coordinate + '%',
          'transform': `translate(-${variantData.x_coordinate}%, -${variantData.y_coordinate}%)`
        });
      }
      
      // Update rotation classes if text_rotation is provided
      if (variantData.text_rotation) {
        // Remove existing rotation classes
        textOverlay.removeClass('text-rotate-ccw text-rotate-cw text-rotate-horz');
        
        // Add new rotation class based on variant data
        if (variantData.text_rotation.includes('counterclockwise')) {
          textOverlay.addClass('text-rotate-ccw');
        } else if (variantData.text_rotation.includes('clockwise')) {
          textOverlay.addClass('text-rotate-cw');
        } else if (variantData.text_rotation.includes('horizontal')) {
          textOverlay.addClass('text-rotate-horz');
        }
      }
    }
  }

  // Function to update monogram font size based on variant data
  function updateMonogramFontSize(variantData) { 
     
    if (variantData.font_size && variantData.font_size !== null) {
      const customFontSize = parseInt(variantData.font_size);
      const tabletFontSize = Math.round(customFontSize * 1.5);
      const smallTabletFontSize = Math.round(customFontSize * 1.35);
      const largeMobileFontSize = Math.round(customFontSize * 1.2);
      const mobileFontSize = Math.round(customFontSize * 0.9);
      
       
      // Find all monogram text overlays
      const $overlays = $m('.monogram-text-overlay');
       
      // Apply font sizes directly to the elements using inline styles
      $overlays.each(function(index) {
        const $overlay = $(this);
        
        // Set base font size
        $overlay.css('font-size', customFontSize + 'px');
         
        // Store the font sizes as data attributes for media query handling
        $overlay.data('font-size-base', customFontSize);
        $overlay.data('font-size-tablet', tabletFontSize);
        $overlay.data('font-size-small-tablet', smallTabletFontSize);
        $overlay.data('font-size-large-mobile', largeMobileFontSize);
        $overlay.data('font-size-mobile', mobileFontSize);
      });
      
      // Update the CSS rules in the style tag to match the new font sizes
      updateMonogramFontSizeCSS(customFontSize, tabletFontSize, smallTabletFontSize, largeMobileFontSize, mobileFontSize);
      
      // Add a single media query handler that updates all overlays
      updateMonogramFontSizeForScreenSize();
    }  
  }
  
  // Function to update the CSS rules with new font sizes
  function updateMonogramFontSizeCSS(baseSize, tabletSize, smallTabletSize, largeMobileSize, mobileSize) {
    // Find and update the existing style tag
    const styleRoot = monogramScope().querySelector ? monogramScope() : document;
    if (styleRoot === document && document.querySelectorAll('.product-section').length > 1) return;
    const existingStyle = styleRoot.querySelector('style[id^="monogram-font-size-"]');
    if (existingStyle) {
      // Rules are scoped to this section so panels for other products on the
      // same page keep their own sizes.
      const sel = (styleRoot.id ? '#' + CSS.escape(styleRoot.id) + ' ' : '') + '.monogram-text-overlay';
      const newCSS = `
        ${sel} {
          font-size: ${baseSize}px;
        }
        
        @media screen and (min-width: 600px) and (max-width: 768px) {
          ${sel} {
            font-size: ${tabletSize}px;
          }
        }
        
        @media screen and (min-width: 521px) and (max-width: 599px) {
          ${sel} {
            font-size: ${smallTabletSize}px;
          }
        }
        
        @media screen and (min-width: 471px) and (max-width: 520px) {
          ${sel} {
            font-size: ${largeMobileSize}px;
          }
        }
        
        @media screen and (max-width: 470px) {
          ${sel} {
            font-size: ${mobileSize}px;
          }
        }
      `;
      
      existingStyle.textContent = newCSS;
     }
  }
  
  // Function to update font sizes based on current screen size
  function updateMonogramFontSizeForScreenSize() {
    const $overlays = $m('.monogram-text-overlay');
    
    $overlays.each(function() {
      const $overlay = $(this);
      const baseSize = $overlay.data('font-size-base');
      
      if (!baseSize) return; // Skip if no font size data
      
      const width = window.innerWidth;
      let fontSize = baseSize;
      
      if (width <= 470) {
        fontSize = $overlay.data('font-size-mobile');
      } else if (width <= 599) {
        fontSize = $overlay.data('font-size-large-mobile');
      } else if (width <= 768) {
        fontSize = $overlay.data('font-size-tablet');
      }
      
      $overlay.css('font-size', fontSize + 'px');
    });
  }
  
  // Listen for window resize to update font sizes
  $(window).on('resize', updateMonogramFontSizeForScreenSize);
  
  // Function to inspect CSS rules affecting an element
  function inspectElementCSS(element) {
    const styles = window.getComputedStyle(element); 
    
    // Check if there are any !important rules
    const elementStyle = element.style; 
    
    return styles;
  }
  
  // Function to reset and initialize selections after variant change
  function resetAndInitializeSelections() {
    // Clear all existing selections
    $m('.monogram-swatch-wrapper').removeClass('is-selected');
    $m('input[name^="monogram-style"], input[name^="monogram-color"]').prop('checked', false);
    
    // Clear hidden property inputs to remove any previous values
    $m('[id^="monogram-style-property"]').val('');
    $m('[id^="monogram-color-property"]').val('');
    
    // Clear title attributes and text content on monogram text overlays
    $m('.monogram-text-overlay').attr('title', '').text('');
    
    // Clear any existing font size styles to prevent conflicts
    $m('.monogram-text-overlay').css('font-size', '');
    
    // Select first style option if available
    const firstStyleInput = $m('input[name^="monogram-style"]').first();
    if (firstStyleInput.length) {
      firstStyleInput.prop('checked', true);
      firstStyleInput.closest('.monogram-swatch-wrapper').addClass('is-selected');
      
      const firstStyle = firstStyleInput.val();
      
      // Show/hide color swatches based on selected style
      const colorSwatches = $m('.color-swatch-wrapper');
      colorSwatches.hide();
      
      // Only show color swatches if the first style is 'Color'
      if (firstStyle.includes('Color')) {
        // Show the color options section
        $m('.monogram-color-options').show();
        
        // Show all color swatches when the first style includes "Color"
        colorSwatches.each(function() {
          $(this).show();
        });
        
        // Select first visible color option
        const firstVisibleColorInput = $m('.color-swatch-wrapper:visible input[name^="monogram-color"]').first();
        if (firstVisibleColorInput.length) {
          firstVisibleColorInput.prop('checked', true);
          firstVisibleColorInput.closest('.color-swatch-wrapper').addClass('is-selected');
        }
      } else {
        // Hide the entire color options section for Embossed style
        $m('.monogram-color-options').hide();
      }
      
      // Update displays and properties AFTER setting selections
      updateColorNameDisplay();
      updateMonogramProperties();
      updatePriceVisibility();
      
      // Update text overlay color based on the selected style
      if (firstStyle === 'Embossed') {
        syncEmbossedColorWithMainVariant();
        // Also update text overlay to use embossed color
        updateMonogramTextOverlayToEmbossedColor();
      } else {
        // Update monogram text overlay color for other styles
        updateMonogramTextOverlayColor();
      }
    }
  }

// Add event listeners for modal monogram input field
$(document).on('keyup input', '.monogram-modal-container .monogram__input-field', function() {
  monogramActiveScope = monogramScopeFrom(this);
  // Normalise pasted / autofilled values the same way keystrokes are filtered
  const inputValue = this.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 3);
  if (this.value !== inputValue) this.value = inputValue;
  $m('.monogram-text-overlay').text(inputValue || '');
  $m('.monogram-text-overlay').attr('title', inputValue);
  // Update monogram text overlay color
  updateMonogramTextOverlayColor();
  // Keep the hidden properties and Add to Cart state in sync for non-key input (paste, autofill)
  updateMonogramProperties();
  updateAddToCartButtonState();
});

  // Live character filtering for the panel's input. Delegated once so it also
  // reaches inputs injected later by quick-view modals, and scoped to the panel
  // the input belongs to.
  var monogramKeyFilterBound = false;
  function setKeyUpEvent() {
    if (monogramKeyFilterBound) return;
    monogramKeyFilterBound = true;
    $(document).on('keypress keyup', '.monogram__input-field', function(e){
      monogramActiveScope = monogramScopeFrom(this);
      var key = e.key;
      if (!isValid(key)) {
          e.target.value = e.target.value.replace(/[^a-z0-9\s]/gi, '');
          e.preventDefault();
          return false;
      }else{
        e.target.value = e.target.value.toUpperCase();
        $(this).attr('value', e.target.value)
      }
    });
  }

  function isValid(str) {
    // Allow only alphanumeric characters (A-Z, a-z, 0-9)
    return /^[a-zA-Z0-9]*$/.test(str);
  }
  
  
function renderFunctions() {
  function closeMonogramPopup(action, wrap, pop_wrap){
      wrap.find('.monogram-error').remove();
      const monogram_input = wrap.find('.monogram__input-field');
      const monogram_button = wrap.find('.add_monogram')
      const form_id = wrap.attr('data-form-id')
      let form = $(`form#${form_id}`)
      if(!form || form.length == 0 ){
        form = $(`form#${form_id}-modal`)
      }
      const prod_id = monogram_input.attr('prod-id')
      const monogram_in_prod_form = $(`.monogram-input--prop-${prod_id}`)
      const monogram_link = wrap.find('.custom-monogram-link');
      const text = monogram_input.val();

      if(action === 'add'){
        if(text === ''){
          monogram_input.addClass('error');
          return false;
        }else if(!isValid(text)){
          monogram_input.addClass('error');
          $('<span class="monogram-error">Invalid</span>').insertAfter(monogram_button);
          return false;
        }else if(text.length > 3){
          monogram_input.addClass('error');
          $('<span class="monogram-error">Only 3 characters allowed</span>').insertAfter(monogram_button);
          return false;
        }else if(/[.]/g.test(text) === true) {
          monogram_input.addClass('error');
          $('<span class="monogram-error">Invalid</span>').insertAfter(monogram_button);
          return false;
        }else{
          // If the text is valid 

          // If monogram error message is showing, remove it
          if($('.monogram-error-atc-popup')){
            $('.monogram-error-atc-popup').fadeOut(function(){
              $('.monogram-error-atc-popup').remove()
            })
          }
          monogram_input.removeClass('error');
          pop_wrap.find('.custom-monogram-popup, .custom-monogram-overlay').hide();
          monogram_input.attr('disabled','')


          // Update the hidden input field in the product form with the new value
          const value = monogram_input.val()
          monogram_in_prod_form.val(value) 
         if(value != "" ){
            if(monogram_in_prod_form && monogram_in_prod_form.length){
              $(monogram_in_prod_form).val(value)
              $(monogram_in_prod_form).attr('value', value)
            }else{
              const property = $(`<input type="hidden" aria-label="monogram-input" id="monogram-input--prop-${prod_id }" type="text" value="${value}" d-placeholder="" placeholder="" name="properties[Monogram]" data-maxlength="3" maxlength="3"  class="monogram-input--prop-${prod_id} monogram__input-field">`)
              
              $(form).prepend(property)
            }
          }
          // Hides add button
          const add_button = wrap.find('.add_monogram.button')
          $(add_button).css('display', 'none')

          // Shows delete button to page with click event 
          const delete_button = wrap.find('.delete_monogram')
          if(!$(delete_button).length){
            $('<button type="button" class="delete_monogram button">Remove</button>pop_wrap.find').insertAfter($(wrap).find('.custom-monogram-popup-form button'))  
            //Click handler on Delete monogram button
            $('.delete_monogram').on('click', function(){
              closeMonogramPopup('delete', $(wrap), $(pop_wrap));
            });
          }else{
            $(delete_button).css('display', 'block')
          }
          
        }
      }else if(action === 'delete'){
        // Re-enables the input field 
        monogram_input.removeAttr('disabled')
        // removes value from the hidden input in product form
        monogram_in_prod_form.val('')// old code to reset hidden input field 
        monogram_input.val(''); 
        monogram_input.removeClass('error');
        // Updated code to remove value from hidden input in product form
        let valueProp = $(".product-single__form .monogram__input-field")[0]// new code to reset hidden input value to ''
        $(valueProp).val('') // new code to reset hidden input value to ''
        // pop_wrap.find('.custom-monogram-popup, .custom-monogram-overlay').hide();
        $('.delete_monogram').css('display', 'none')
        $('.add_monogram.button').css('display', 'block')
      }else{
        pop_wrap.find('.custom-monogram-popup, .custom-monogram-overlay').hide();
        $('.lifetime-guarantee-badge').focus();
      }
      // if(text === ''){
      //   monogram_input.prop('disabled', true);
      // }
    }
    
  setKeyUpEvent()
    $('.custom-monogram-link').on('click', function(e) {
      e.preventDefault();
      let pop_wrap = $(this).closest(".product-single__meta").find(".monogram-pop-wrap")
      pop_wrap.find('.custom-loader-overlay').show();
      $('.custom-loader').show();
      pop_wrap.find('.custom-monogram-popup').find('.monogram-close-button').focus();
      pop_wrap.find('.custom-monogram-popup').find('.custom-monogram-popup-close').attr('aria-label','close');
      pop_wrap.find('.custom-monogram-popup').find('.custom-monogram-popup-close').focus();
      if(pop_wrap.find('.custom-monogram-popup').attr('aria-modal') != 'true') {
        pop_wrap.find('.custom-monogram-popup').attr('role','dialog');
        pop_wrap.find('.custom-monogram-popup').attr('aria-modal','true');
        pop_wrap.find('.custom-monogram-popup').attr('aria-label','Personalize your Product name');
      }
      pop_wrap.find('.custom-monogram-popup-form input').removeAttr('disabled');
      $('.custom-loader-overlay').hide();
      $('.custom-loader').hide();
      pop_wrap.find('.custom-monogram-popup, .custom-monogram-overlay').show();
          //return false;
    });
    function removeErrorMsg() {
      if($(".monogram-error-atc-popup")[0]){
        $('.monogram-error-atc-popup').fadeOut(function(){
          $('.monogram-error-atc-popup').remove()
        })
      }
    }
    $m('.monogram__input-field').on('keypress keyup', function(e){
      var key = e.key;
      if (!isValid(key)) {
          e.target.value = e.target.value.replace(/[^a-z0-9\s]/gi, '');
          e.preventDefault();
          return false;
      }else{
        e.target.value = e.target.value.toUpperCase();
        if(!$('.add_monogram').hasClass('is-active')){
          $('.add_monogram').addClass('is-active')
        }else{
          // If the last key action was deleting all values in the input field
          // Revert add button to inactive, hide any error message
          if($m('.monogram__input-field').val() == ""){
            $('.add_monogram').removeClass('is-active')
            removeErrorMsg()
          }
        }
        
        // Update monogram properties when text changes
        updateMonogramProperties();
        
        // Update monogram text overlay color when typing
        updateMonogramTextOverlayColor();
      }
    });
    
    function isValid(str) {
      return /^[a-zA-Z0-9]+$/.test(str);
    }
    
    //Click handler on Add monogram button
    $('.add_monogram').on('click', function(){
      const parent = $(this).closest('.custom-monogram-popup-form')[0]
      const monogram_input = $(parent).find('.monogram__input-field')
      if (!isValid($(monogram_input[0]).val())) {
        if(!$(monogram_input).hasClass('error')){
          monogram_input.addClass('error');
          $('<span class="monogram-error">Invalid</span>').insertAfter($(this));
        }
        return false;
      }

      if($('.add_monogram').hasClass('is-active')){
        $('.add_monogram').removeClass('is-active')
      }
      removeErrorMsg()
      closeMonogramPopup('add', $(this).closest(".product-single__meta").find(".monogram-wrap"), $(this).closest(".product-single__meta").find('.monogram-pop-wrap'));
    });
    
    //Click handler on close icon and close button on popup
    $('.custom-monogram-popup-close').on('click', function(e) {
      closeMonogramPopup('', $(this).closest(".product-single__meta").find(".monogram-wrap"), $(this).closest(".product-single__meta").find('.monogram-pop-wrap'));
      e.preventDefault();
    });
    $('.monogram-close-button').on('click', function(e) {
      closeMonogramPopup('', $(this).closest(".product-single__meta").find(".monogram-wrap"), $(this).closest(".product-single__meta").find('.monogram-pop-wrap'));
      e.preventDefault();
    });
    $('.custom-monogram-popup-close').keydown(function(e) {
      if(e.which == 13) {
        closeMonogramPopup('', $(this).closest(".product-single__meta").find(".monogram-wrap"), $(this).closest(".product-single__meta").find('.monogram-pop-wrap'));
        e.preventDefault();
      }
    });
    $(document).on('focus', '#closeRefocus', function(){
        document.querySelector('.custom-monogram-popup-close').focus();
    });
    $(document).on('keydown blur', '.custom-monogram-popup.has-form', function(e){
      if (e.shiftKey && e.keyCode === 9) {
          return false;
      }
    });
    $(document).on('click', '.custom-monogram-overlay', function(e) {
      closeMonogramPopup();
      e.preventDefault();
    
      return false;
    });
    $(document).keyup(function(e) {
        if (e.keyCode === 27 && $('.custom-monogram-popup:visible').length > 0) {
          closeMonogramPopup();
        }
    });
    $(document).on('click', '.details-modal', function(){
      $('.custom-monogram-overlay, .custom-shipping-popup').fadeIn();
    })
    $(document).on('click', '.custom-shipping-popup-close', function(){
      $('.custom-monogram-overlay, .custom-shipping-popup').fadeOut();
    })
  }
  renderFunctions()
  $('.quick-product__btn').each(function(){
    $(this).on('click', function(){
      setTimeout(() => { 
        renderFunctions()
      }, 1500);
    })
  })

  // Monogram Modal ADD TO CART functionality
  $(document).on('click', '.monogram-modal-atc-btn', function(e) {
    e.preventDefault();
  monogramActiveScope = monogramScopeFrom(this);
    
    const button = $(this);
    const productId = button.attr('data-product-id');
    const variantId = button.attr('data-variant-id'); // Use .attr() instead of .data() to get updated value
    const monogramFeeProductId = button.attr('data-monogram-fee-product-id');
    const monogramFeeSku = button.attr('data-monogram-fee-sku');
     
    // Get selected monogram options
    const selectedStyle = $m('input[name^="monogram-style"]:checked').val();
    const selectedColor = $m('input[name^="monogram-color"]:checked').val();
    const monogramText = $m('.monogram__input-field').val();
    
    // Validate that style is selected and color is selected (if required)
    if (!selectedStyle) {
      alert('Please select a style for your monogram.');
      return;
    }
    
    // Color is only required for non-Embossed styles
    if (selectedStyle !== 'Embossed' && !selectedColor) {
      alert('Please select a color for your monogram.');
      return;
    }
    
    // Validate that monogram text is entered
    if (!monogramText || monogramText.trim() === '') {
      alert('Please enter your monogram text.');
      return;
    }
    
    // Validate monogram text format
    if (!isValid(monogramText)) {
      alert('Monogram text can only contain letters and numbers.');
      return;
    }
    
    if (monogramText.length > 3) {
      alert('Monogram text cannot exceed 3 characters.');
      return;
    }
    
    // Add loading state
    button.addClass('btn--loading');
    button.prop('disabled', true);
    
    // Prepare cart items to add
    const items = [];
    
    // Add main product with monogram properties
    const properties = {
      'Monogram': monogramText.toUpperCase(),
      'Monogram Style': selectedStyle
    };
    
    // Only add color property if it's selected (Color style)
    if (selectedColor) {
      properties['Monogram Color'] = selectedColor;
    }
    
    const mainProductItem = {
      id: parseInt(variantId), // Ensure it's a number
      quantity: 1,
      properties: properties
    };
    items.push(mainProductItem);
    
    // Add monogram fee product only if style is not Embossed
    if (selectedStyle !== 'Embossed') {
      // Get the fee product variant ID from the button's data attribute (set by theme setting)
      const feeProductVariantId = button.attr('data-monogram-fee-product-id');
      
      if (feeProductVariantId) {
        const feeProductItem = {
          id: parseInt(feeProductVariantId),
          quantity: 1
        };
        items.push(feeProductItem);
      } else {
        console.warn('Monogram fee product variant ID not found in theme settings');
      }
    }  
     
    
    // Add items to cart via fetch (native — avoids STOQ/RestockRocket's
    // XMLHttpRequest.prototype.open hijack that was throwing on the jQuery $.ajax XHR
    // and firing the error path even though the item was added to the cart)
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function(response) {
        if (!response.ok) {
          // Match jQuery's behavior: a non-2xx response is an error, not success
          return response.json().catch(function() { return {}; }).then(function(body) {
            throw new Error(body && body.description ? body.description : 'Cart add failed');
          });
        }
        return response.json();
      })
      .then(function(response) {
        // Success - trigger cart update and close modal
        document.dispatchEvent(new CustomEvent('cart:build'));

        // Open the cart drawer
        document.dispatchEvent(new CustomEvent('cart:open'));

        // Close the monogram modal
        const outerWrapper = button.closest('.monogram-outer-wrapper');
        outerWrapper.removeClass('is-open');

        // Enable body scrolling when modal closes
        enableBodyScroll();

        // Clear the monogram input field
        $m('.monogram__input-field').val('');

        // Reset the "Add" button state
        $('.add_monogram').removeClass('is-active');

        // Hide the "Remove" button and show the "Add" button (same as delete action)
        $('.delete_monogram').css('display', 'none');
        $('.add_monogram.button').css('display', 'block');

        // Re-enable the input field
        $m('.monogram__input-field').removeAttr('disabled');

        // Update monogram properties (clear them)
        updateMonogramProperties();

        // Clear title attributes and text content on monogram text overlays
        $m('.monogram-text-overlay').attr('title', '').text('');

        // Reset button state
        button.removeClass('btn--loading');
        button.prop('disabled', false);
      })
      .catch(function(error) {
        // Error handling
        console.error('Error adding items to cart:', error);
        alert('There was an error adding items to your cart. Please try again.');

        // Reset button state
        button.removeClass('btn--loading');
        button.prop('disabled', false);
      });
  });

  // Click event 
  let counter1 = 0
  const checkLoaded = setInterval(function(){
    let buttons = $('.quick-product__btn')
    if(buttons && buttons.length > 0 || counter1 >= 30){
      // Waits for quickview buttons to load on page before looping and setting click functions
      $(buttons).each(function(){
        $(this).on('click', function(e){

          setKeyUpEvent()
          let counter2 = 0
          const checkExist = setInterval(function(){
            let grid_prod = $(e.target).closest('.grid-product')
            let tabs;
            let grid_prod_id;
            if($(grid_prod).hasClass('ss__result')){
              // The Search Spring-built recommendations on PDP, cart, etc. 
              // Has a different structure for the grid product / quickshop modal (not nested within grid product parent element)
              grid_prod_id = $(e.target).closest('.grid-product').attr('data-product-id')
              tabs = $(`div#QuickShopModal-${grid_prod_id}`).find('.tablinks')
            }else{
              // Targets native YMAL /featured collection sections (HP, etc) where 
              // Quickshop modal is nested within the grid product element 
              tabs = $(e.target).closest('.grid-product').find('.tablinks')
            }

            if(tabs && tabs.length > 0 || counter2 >= 30){
              renderFunctions()
              clearInterval(checkExist)
            }
            counter2 ++
          }, 300);
        })
      })
      clearInterval(checkLoaded)
    }
    counter1 ++
  }, 300);

  // Function to show/hide monogram button based on selected variant
  function toggleMonogramButton() {
    const monogramButton = $m('.monogram-modal-open');
    if (!monogramButton.length) return;
    
    // Find the currently selected variant input
    const selectedInput = $m('input[data-variant-input]:checked');
    if (!selectedInput.length) return;
    
    // Check if the selected variant allows monogramming
    const allowsMonogram = selectedInput.attr('data-allow-monogram') === 'true';
    
    // Also check if the variant swatch is disabled
    const isDisabled = selectedInput.closest('.variant-input').find('.variant__button-label').hasClass('disabled');
    
    if (allowsMonogram && !isDisabled) {
      monogramButton.removeClass('monogram-disabled');
    } else {
      monogramButton.addClass('monogram-disabled');
    }
  }

  // Listen for variant change events
  $(document).on('change', 'input[data-variant-input]', function() {
    monogramActiveScope = monogramScopeFrom(this);
    toggleMonogramButton();
  });

  // Initialize on page load
  toggleMonogramButton();
  
  // Cleanup function to ensure scrolling is re-enabled
  function cleanupModalScroll() {
    // Remove all modal-open classes in case multiple modals were opened
    document.body.classList.remove('modal-open');
  }
  
  // Add cleanup on page unload
  $(window).on('beforeunload', cleanupModalScroll);
  
  // Set initial font size if variant data is available
  const initialVariantInput = $m('input[data-variant-input]:checked');
  if (initialVariantInput.length) {
    const initialVariantId = initialVariantInput.data('variant-id');
    const variantDataScript = monogramVariantDataScript();
    if (variantDataScript) {
      try {
        const variantData = JSON.parse(variantDataScript.textContent);
        const currentVariantData = variantData[initialVariantId];
        if (currentVariantData && currentVariantData.font_size) {
          // Set initial font size
          updateMonogramFontSize(currentVariantData);
        }
      } catch (error) {
        console.log('Error setting initial font size:', error);
      }
    }
  }
});

